import { render, staticRenderFns } from "./TableCutoffs.vue?vue&type=template&id=739ffcff&"
import script from "./TableCutoffs.vue?vue&type=script&lang=js&"
export * from "./TableCutoffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports